export default __webpack_public_path__ + "static/media/WoodedClearing.6d175271.png";